import Svg, { Circle, G, Path } from 'react-native-svg'
const BluetoothSymbol = ({ width, height, color }) => (
  <Svg width={width} height={height} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <G stroke={color} strokeWidth={8} fill="none" strokeLinecap="round" strokeLinejoin="round">
      <Path d="M 32 70 L 68 30 L 50 12 L 50 88 L 68 70 L 32 30" />
      <Circle cx={16} cy={50} r={6} fill={color} stroke="none" />
      <Circle cx={84} cy={50} r={6} fill={color} stroke="none" />
    </G>
  </Svg>
)

export default BluetoothSymbol
